import { useLocation } from "wouter";
import { queueSection, scrollToSection, sectionId } from "@/components/powlo/sectionNav";

export default function SectionLink({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: React.ReactNode;
}) {
  const [location, navigate] = useLocation();
  const id = sectionId(href);

  return (
    <a
      href={href}
      className={className}
      onClick={(event) => {
        if (!id) {
          event.preventDefault();
          navigate(href);
          return;
        }
        event.preventDefault();
        if (location === "/") {
          scrollToSection(id);
          return;
        }
        queueSection(id);
        navigate("/");
      }}
    >
      {children}
    </a>
  );
}
